// libs
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// actions
import actions from '../../../actions/search';

// component
import SearchForm from './form/SearchForm';
import SearchResults from './results/SearchResults';

// Functions
import { getHelmetTags, getLoadingHelmetTags } from '../../tools/helmetHelpers';

// Styles
import './styles.scss';

class Search extends Component {
  constructor(props, { initialRender, customStore }) {
    super(props);
    const { fetchSearchFilters, fetchSeoData, slug } = props;
    if (initialRender) {
      fetchSearchFilters(customStore);
      fetchSeoData(slug, customStore);
    }
    this.setQuery = this.setQuery.bind(this);
    this.updateResults = this.updateResults.bind(this);
    this.state = {
      query: '',
    };
  }
  componentDidMount() {
    const { filters, fetchSearchFilters, seoData, fetchSeoData, slug } = this.props;
    if (filters.length === 0) {
      fetchSearchFilters();
    }
    if (Object.keys(seoData).length === 0) {
      fetchSeoData(slug);
    }
    if (window) {
      window.scrollTo(0, 0);
    }
  }

  setQuery(query) {
    this.setState({ query });
  }

  updateResults() {
    const { fetchMoreSearchResults, currentPage } = this.props;
    const { query } = this.state;
    fetchMoreSearchResults(query ? `${query}&page=${currentPage + 1}` : `?page=${currentPage + 1}`);
  }

  render() {
    const {
      filters,
      isLoading,
      isLoadingFilters,
      moreResultsAvailable,
      resultsCount,
      resultsShown,
      searchResults,
      seoData,
    } = this.props;
    const { t } = this.context;
    return (
      <div>
        {isLoading ? getLoadingHelmetTags(t) : getHelmetTags(t, seoData)}
        <div className="search">
          <SearchForm
            isLoading={isLoading}
            isLoadingFilters={isLoadingFilters}
            filters={filters}
            setQuery={this.setQuery}
          />
          <SearchResults
            resultsCount={resultsCount}
            resultsShown={resultsShown}
            searchResults={searchResults}
            moreResultsAvailable={moreResultsAvailable}
            updateResults={this.updateResults}
            isLoading={isLoading}
          />
        </div>
      </div>
    );
  }
}

Search.propTypes = {
  currentPage: PropTypes.number.isRequired,
  fetchMoreSearchResults: PropTypes.func.isRequired,
  fetchSearchFilters: PropTypes.func.isRequired,
  fetchSeoData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoadingFilters: PropTypes.bool.isRequired,
  filters: PropTypes.array.isRequired,
  moreResultsAvailable: PropTypes.bool.isRequired,
  resultsCount: PropTypes.number.isRequired,
  resultsShown: PropTypes.number.isRequired,
  searchResults: PropTypes.array.isRequired,
  seoData: PropTypes.object.isRequired,
  slug: PropTypes.string.isRequired,
};

Search.contextTypes = {
  customStore: PropTypes.object,
  initialRender: PropTypes.bool,
  t: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    currentPage: state.search.currentPage,
    filters: state.search.filters,
    isLoading: state.search.isLoading,
    isLoadingFilters: state.search.isLoadingFilters,
    moreResultsAvailable: state.search.moreResultsAvailable,
    resultsCount: state.search.resultsCount,
    resultsShown: state.search.resultsShown,
    searchResults: state.search.results,
    seoData: state.search.seoData,
  };
}

export default connect(mapStateToProps, actions)(Search);



// WEBPACK FOOTER //
// ./src/app/components/pages/search/Search.js